// extracted by mini-css-extract-plugin
export default {"wrapper":"_8f3ddf5e","reduceSize":"_15f2abe8","artTitle":"_4a80dd6a","artCreationDate":"_30487e57"};